import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';
import type ReactRendererService from 'garaje/services/react-renderer';
import type StateService from 'garaje/services/state';
import type { Root } from 'react-dom/client';

export default class CommunicationsAlertsController extends Controller {
  @service declare reactRenderer: ReactRendererService;
  @service declare state: StateService;

  private root?: Root;

  @action
  async injectComponent(): Promise<void> {
    const { ThreatDashboard } = await import('reactRichComponents/communication/ThreatDashboard');

    const locationId = this.state.currentLocation.id;

    this.root = await this.reactRenderer.render(ThreatDashboard, 'react__threat-dashboard', {
      locationId,
      companyId: this.state.currentCompany.id,
    });
  }

  @action
  destroyComponent(): void {
    if (this.root) {
      this.reactRenderer.unmount(this.root);
      this.root = undefined;
    }
  }
}
